import { Builder } from "@builder.io/react";
import { availablePageTypes, registerMenuGroups, commonInputs } from "./helper";
import { BusinessGuideListing, CaseStudiesList, MarketInsightListing, LatestArticles, UseCasesListing, ProductListing, IndustryListing, ResourceListing } from "@/components/Listing";

const articleListing = [
  {
    name: "Article Listing",
    items: [
      { name: "Case Study Listing" },
      { name: "Market Insight Listing" },
      { name: "Business Guide Listing" },
      { name: "Latest Articles" },
      { name: "Use Cases Listing" },
      { name: "Product Listing" },
      { name: "Industry Listing" },
      { name: "Resource Listing" }
    ]
  },
];

export const registerListingComponents = () => {
  registerMenuGroups(articleListing);

  Builder.registerComponent(LatestArticles, {
    name: "Latest Articles",
    friendlyName: "Latest Articles",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "title",
        type: "text",
        defaultValue: "Latest Insights",
      },
      {
        name: "subtitle",
        type: "richText",
        defaultValue: "Exploring cutting-edge technologies shaping tomorrow's digital landscape",
      },
      {
        name: "readMoreButtonText",
        type: "text",
        defaultValue: "Read More",
      },
      {
        name: "dataSource",
        type: "string",
        enum: availablePageTypes,
        defaultValue: "case-study",
        helperText: "refresh admin to view updated source",
      },
    ],
  });
  
  Builder.registerComponent(CaseStudiesList, {
    name: "Case Study Listing",
    friendlyName: "Case Study Listing",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
    ],
  });

  Builder.registerComponent(MarketInsightListing, {
    name: "Market Insight Listing",
    friendlyName: "Market Insight Listing",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
    ],
  });

  Builder.registerComponent(BusinessGuideListing, { 
    name: "Business Guide Listing",
    friendlyName: "Business Guide Listing",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
    ],
  });

  Builder.registerComponent(UseCasesListing, {
    name: "Use Cases Listing",
    friendlyName: "Use Cases Listing",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "title",
        type: "text",
        defaultValue: "Here is how we help.",
      },
      {
        name: "numbersPerRow",
        type: "string",
        enum: ["2", "3", "4"],
        defaultValue: "2",
      },
    ],
  }); 

  Builder.registerComponent(ProductListing, {
    name: "Product Listing",
    friendlyName: "Product Listing",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "heroContent",
        type: "object",
        defaultValue: {

        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.secondaryButtonInputs(),
        ],
      },
      {
        name: "title",
        type: "text",
        defaultValue: "Explore our products",
      },
      {
        name: "products",
        type: "list",
        helperText: "Please add products to the list for on page filtering",
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
            includeLink: true,
          }),
          {
            name: "features",
            type: "list",
            defaultValue: [],
            subFields: [
              { name: "feature", type: "text" },
              { name: "icon", type: "text" },
            ],
          },
          {
            name: "filterByBusiness",
            type: "list",
            defaultValue: [],
            subFields: [
              { name: "business", type: "text" },
            ],
          },
          {
            name: "filterByUseCase",
            type: "list",
            defaultValue: [],
            subFields: [
              { name: "useCase", type: "text" },
            ],
          },
        ],
      },
    ],
  }); 

  Builder.registerComponent(IndustryListing, {
    name: "Industry Listing",
    friendlyName: "Industry Listing",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "title",
        type: "text",
        defaultValue: "Find your industry",
      },
      {
        name: "subtitle",
        type: "text",
        defaultValue: "Lorem ipsum dolor sit amet consectetur. Diam eleifend elementum elit montes egestas.",
      },
      {
        name: "industries",
        type: "list",
        helperText: "Please add industries to the list for on page filtering",
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
            includeLink: true,
          }),
        ],
      },
    ],
  }); 

  Builder.registerComponent(ResourceListing, {
    name: "Resource Listing",
    friendlyName: "Resource Listing",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "title",
        type: "text",
        defaultValue: "Resources hub",
      },
      {
        name: "subtitle",
        type: "text",
        defaultValue: "Browse our latest insights, guides, and support tools, all in one place.",
      },
      {
        name: "resources",
        type: "list",
        helperText: "Please add resources to the list for on page filtering",
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
            includeLink: true,
          }),
        ],
      },
    ],
  }); 
};

